import React from 'react'
import Header from '../componets/header/header'
import Footer from '../componets/footer/footer'
import home1 from "../../assests/home1.webp";
import home2 from "../../assests/home2.webp";
import home3 from "../../assests/about_image.webp";
function Blogpage() {
    return (
        <div>
            <Header />
            <div>
                <div className="blog-section">
                    <h2 className="blog-title">BEST DIGITAL MARKETING BLOGS</h2>

                    <div className="blog-cards">
                        {[
                            {
                                image: home1,
                                title: "The Digital Marketing for Modern Businesses",
                                desc: "Stay ahead of the curve with the latest digital marketing strategies tailored for modern businesses.",
                                link: "/blog1"
                            },
                            {
                                image: home2,
                                title: "Digital Marketing Goodness",
                                desc: "Explore the key principles that make digital marketing work for your business.",
                                link: "/blog2"
                            },
                            {
                                image: home3,
                                title: "Welcome to the Offbeat Digital Marketing",
                                desc: "Discover the unconventional yet effective strategies that are transforming digital marketing.",
                                link: "/blog3"
                            },
                        ].map((card, index) => (
                            <div className="blog-card" key={index} data-aos="fade-up" data-aos-delay={index * 100}>
                                <div className="blog-img-wrapper">
                                    <img src={card.image} alt={card.title} className="blog-img" />
                                </div>

                                <div className="blog-content">
                                    <h4 className="blog-heading">{card.title}</h4>
                                    <p className="blog-desc">{card.desc}</p>
                                    <a href={card.link} className="blog-read-btn">Read More →</a>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
            <Footer />
        </div>
    )
}

export default Blogpage
